import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Form, Space } from "antd";
import React, { useEffect, useCallback } from "react";
import { useState } from "react";
import {
  addTechSpecialized,
  deleteTechSpecialized,
  getTechSpecialized,
  updateTechSpecialized,
} from "../../api/TechSpecializedApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import adnYesNoModal from "../common/adnYesNoModal/AdnYesNoModal";
import { appTitle } from "../common/GeneralConfigurations";
import { TechSpecializedListPageForm } from "./TechSpecializedListPageForm";
import { useTranslation } from "react-i18next";

export const ManageTechSpecializedListPage = () => {
  const { t } = useTranslation();
  const title = t("techSpecialized.title");
  const [techs, setTechs] = useState([]);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [modalTechId, setModalTechId] = useState(null);
  const [refetchData, setRefetchData] = useState(0);
  const [orderBy, setOrderBy] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    document.title = `${appTitle} - ${title}`;
  }, [title]);
  const fetchData = useCallback(() => {
    getTechSpecialized(orderBy)
      .then((res) => {
        if (res.data) {
          setTechs(res.data);
        } else {
          setTechs([]);
        }
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, [orderBy]);

  useEffect(() => {
    fetchData();
  }, [refetchData, fetchData]);

  const handleOrderList = (pag, filter, sorter) => {
    sorter.order === "descend"
      ? setOrderBy("-" + sorter.field)
      : sorter.order === "ascend"
      ? setOrderBy(sorter.field)
      : setOrderBy("");
  };

  const addTech = () => {
    setVisible(true);
    setModalTechId(null);
    form.setFieldsValue({ name: "" });
  };

  const handleDelete = (id) => {
    deleteTechSpecialized(id)
      .then((res) => {
        if (res.status === 200) {
          setRefetchData(refetchData + 1);
          AdnMessageSuccess();
        } else AdnMessageError();
      })
      .catch((err) => console.log(err));
  };

  const columns = [
    {
      title: t("techSpecialized.columns.name"),
      dataIndex: "name",
      key: "name",
      width: "90%",
      sorter: true,
    },
    {
      title: t("techSpecialized.columns.action"),
      key: "action",
      width: "10%",
      render: (text, record) => (
        <Space size="middle">
          <EditOutlined
            style={{ color: "black" }}
            onClick={() => {
              setVisible(true);
              setModalTechId(record.id);
              form.setFieldsValue(record);
            }}
          />
          <DeleteOutlined
            style={{ color: "red" }}
            onClick={() => adnYesNoModal(() => handleDelete(record.id))}
          />
        </Space>
      ),
    },
  ];

  const handleFinish = (values) => {
    setSubmitLoading(true);
    if (!modalTechId) {
      addTechSpecialized(values)
        .then((res) => {
          setSubmitLoading(false);
          if (res.status === 201) {
            setRefetchData(refetchData + 1);
            AdnMessageSuccess();
          } else if (res.status === 400) {
            form.setFields(
              res.data.errors.map((e) => ({
                name: e.message.split(" ")[0].toLowerCase(),
                errors: [e.message],
              }))
            );
            return;
          } else AdnMessageError();
          setVisible(false);
        })
        .catch((err) => console.log(err));
    } else {
      updateTechSpecialized(modalTechId, values)
        .then((res) => {
          setSubmitLoading(false);
          if (res.status === 200) {
            setRefetchData(refetchData + 1);
            AdnMessageSuccess();
          } else if (res.status === 400) {
            form.setFields(
              res.data.errors.map((e) => ({
                name: e.message.split(" ")[0].toLowerCase(),
                errors: [e.message],
              }))
            );
            return;
          } else AdnMessageError();
          setVisible(false);
        })
        .catch((err) => console.log(err));
    }
  };
  const handleBlurName = () => {
    form.setFieldsValue({
      name: form
        .getFieldValue("name")
        ?.trim()
        .split(/\s+/)
        .filter((w) => w !== "")
        .join(" "),
    });
    form.validateFields(["name"]);
  };

  return (
    <TechSpecializedListPageForm
      form={form}
      title={title}
      columns={columns}
      handleOrderList={handleOrderList}
      setVisible={setVisible}
      visible={visible}
      techs={techs}
      addTech={addTech}
      handleFinish={handleFinish}
      modalTechId={modalTechId}
      loading={loading}
      submitLoading={submitLoading}
      handleBlurName={handleBlurName}
    />
  );
};
